// One source of truth for the exact promise shown at collection and stored as
// consent evidence. Client forms render these strings verbatim; the server RPC
// persists the same value with the list row and consent timestamp.
export const SUBSCRIPTION_LISTS = {
  newsletter: {
    consent:
      "The MicroPlastics email has no fixed send date, is usually sent no more than monthly, and covers new scores, corrections, and evidence changes. We do not sell your address or share it for another company's marketing; our email and database providers process it for us. Unsubscribe anytime.",
  },
  android_waitlist: {
    consent:
      "One email when the Android app launches. We do not sell your address or share it for another company's marketing; our email and database providers process it for us. Unsubscribe anytime.",
  },
  detox_challenge: {
    consent:
      "One email if a guided 7-day MicroPlastics challenge becomes available. We do not sell your address or share it for another company's marketing; our email and database providers process it for us. Unsubscribe anytime.",
  },
} as const

// The public subscribe endpoint deliberately gives the same acknowledgement
// for a new address, an active duplicate, and a suppressed address. A form
// submission cannot prove ownership, so it must never reverse or claim to
// reverse an earlier unsubscribe.
export const SUBSCRIPTION_REQUEST_ACKNOWLEDGEMENT =
  'Request received. A prior unsubscribe remains in place. If you previously unsubscribed and want to rejoin, contact us so we can verify the address.'

export type SubscriptionListName = keyof typeof SUBSCRIPTION_LISTS
